<script setup>
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useUserStore } from "@/stores/UserStore";
  import RadioControl from '@/components/RadioControl.vue';

  const userStore = useUserStore();

  const { t } = useI18n();

  const options = computed(() => ({
    windlist: t('siteSettings.windList'),
    livewind: t('siteSettings.liveWind'),
    windmap: t('siteSettings.windMap')
  }));
</script>

<template>
  <div class="jwx-modal__section">
    <div class="jwx-modal__section-body">
      <ul class="jwx-block jwx-table-view" data-surface="1">
        <li v-for="(label, value) in options" :key="value" class="jwx-table-view__row">
          <div class="jwx-table-view__row-content">
            <label :for="'search-results-' + value" class="jwx-table-view__row-label">{{ label }}</label>
            <div class="jwx-table-view__row-actions">
              <RadioControl
                v-model="userStore.searchResultsDisplay"
                name="search-results"
                :id="'search-results-' + value"
                :value="value"
                :srLabel="t('siteSettings.srSelectSearchResults', { label: label.toLowerCase() })"
              />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
